import React from 'react'
import Select from 'react-select'
import { countryPhoneCodes } from 'utils/constants'

function PhoneNumberInput({
    inputName,
    selectName,
    label,
    required,
    placeholderInput,
    inputValue,
    selectValue,
    setFieldValue,
    setFieldTouched,
    onChangeInput,
    onBlurInput,
    errorInput,
    errorSelect,
    disabled,
    infoText,
}) {
    return (
        <div className='flex flex-col space-y-2'>
            <label
                for={inputName}
                className='font-semibold flex text-sm md:text-base lg:text-lg'
            >
                <p>{label}</p>
                {required && (
                    <span className='text-red-500'>*</span>
                )}
            </label>
            <div className='flex flex-col sm:grid sm:grid-cols-2 gap-4'>
                <Select
                    id={selectName}
                    name={selectName}
                    options={countryPhoneCodes}
                    value={selectValue}
                    onChange={(value) => setFieldValue(selectName, value)}
                    onBlur={(value) => setFieldTouched(selectName, true)}
                    isDisabled={disabled}
                    isSearchable={true}
                    placeholder="Select your country code..."
                    className="react-select-container"
                    classNamePrefix="react-select"
                />
                <input
                    id={inputName}
                    className='text-sm sm:text-base lg:text-lg border border-app-light-grey-2 rounded-lg bg-transparent px-3 py-2 focus:outline-none focus:border-2 focus:border-blue-500'
                    value={inputValue}
                    onChange={onChangeInput}
                    onBlur={onBlurInput}
                    placeholder={placeholderInput}
                    disabled={disabled}
                    autoComplete='off'
                />
            </div>
            {infoText && (
                <p className='text-xs md:text-sm text-app-grey'>{infoText}</p>
            )}
            {errorSelect && (
                <p className='text-xs sm:text-sm xl:text-base text-red-500'>{errorSelect}</p>
            )}
            {errorInput && (
                <p className='text-xs sm:text-sm xl:text-base text-red-500'>{errorInput}</p>
            )}
        </div>
    )
}

export default PhoneNumberInput